import React, { useEffect, useState } from 'react';

import '@alife/bc-video-player/index.css';

import { useFavorite } from '@/hooks/useFavorite';
import PageStore from '@/stores/page';
import SkuStore from '@/stores/sku';

import MyLazyComponent from '@/common/lazy-load';
import isNodeServer from '@/utils/isNodeServer';

import loadScript from '../../utils/loadScript';
import ImageList from './img_List/index';
import MainImage from './main_img';

import './index.less';

interface mediaItem {
  type: string;
  [key: string]: any;
}
const CUSTOM_TYPE = ['lightCustomModel', 'customModel', 'customHome'];
const OLD_LIVE_INDEX = 1;
const NEW_LIVE_INDEX = -1;

export default function ProductImage(props: any) {
  const { product, i18n, abtest } = props || {};
  const { productId, mediaExtendInfo, mediaItems = [] } = product;
  const { isFavorite, handleFavorite } = useFavorite(productId);
  const [activeId, setActiveId] = useState(0);
  const [dialogVisible, setDialogVisible] = useState(false);
  // 去除定制
  const [mediaItemsList, setMediaItemsList] = useState(
    mediaItems.filter((item: mediaItem) => !CUSTOM_TYPE.includes(item.type))
  );

  const skuInfo = SkuStore(state => state);
  const pageStore = PageStore(state => state);
  const { isLoaded } = pageStore;

  const ImageDialog = MyLazyComponent(
    () => import(/* webpackChunkName: "image-dialog" */ './img_dialog')
  );

  /**
   * isVideoSecond
   * 有直播：主图1/直播/视频/主图2、3、4、5、6
   * 无直播：主图1/视频/主图2、3、4、5、6
   */
  const isVideoSecond = abtest?.pc_detail_fantasy_reprioritizing_video?.indexOf('video_second') > 0;
  /**
   * isVideoLast
   * 有直播：主图1、2、3、4、5、6/直播/视频
   * 无直播：主图1、2、3、4、5、6/视频
   */
  const isVideoLast = abtest?.pc_detail_fantasy_reprioritizing_video?.indexOf('video_last') > 0;

  //  视频排序优化实验桶标识
  const isReprioritizingVideo = isVideoSecond || isVideoLast;

  // 获取直播插入位置
  const getLiveIndex = () => {
    if (isVideoLast) {
      return NEW_LIVE_INDEX;
    } else {
      return OLD_LIVE_INDEX;
    }
  };
  // 同步渲染、国家站不加载
  const loadLive = () => {
    if (isNodeServer()) return;
    const { liveDataInfo } = mediaExtendInfo;

    // 插入静态资源
    loadScript(
      `//s.alicdn.com/@g/alimsc/icbu-live-bro-biz/${liveDataInfo.liveAssetsDiamondVersion}/js/pcdetail.js`
    );
    loadScript(
      `//s.alicdn.com/@g/alimsc/icbu-live-bro-biz/${liveDataInfo.liveAssetsDiamondVersion}/css/pcdetail.css`,
      true
    );
  };
  // 防止沉浸页出滚动条
  useEffect(() => {
    document.body.style.height = dialogVisible ? '100vh' : 'auto';
    document.body.style.overflow = dialogVisible ? 'hidden' : 'auto';
  }, [dialogVisible]);

  useEffect(() => {
    skuInfo.setSkuImageNone('product');
  }, [activeId]);

  // 处理商品数组
  useEffect(() => {
    // 筛选出 type 为 "image" 的项
    const imageItems = mediaItemsList.filter((item: mediaItem) => item.type === 'image');
    // 筛选出 type 为 "video" 的项
    const videoItem = mediaItemsList.filter((item: mediaItem) => item.type === 'video');
    let newMediaList = imageItems;
    if (videoItem.length > 0 && isReprioritizingVideo) {
      if (isVideoSecond) {
        newMediaList.splice(1, 0, videoItem[0]);
      } else {
        newMediaList.push(videoItem[0]);
      }
    } else {
      newMediaList = mediaItemsList;
    }
    // 增加直播
    if (mediaExtendInfo?.liveDataInfo) {
      const { liveDataInfo } = mediaExtendInfo;
      newMediaList.splice(getLiveIndex(), 0, {
        bizType: '',
        cover: liveDataInfo.coverUrl,
        params: liveDataInfo,
        type: 'live',
      });
      loadLive();
    }
    setMediaItemsList(newMediaList);
  }, []);

  if (!mediaItemsList) return null;

  return (
    <div className="detail-product-image-container">
      <div className="detail-product-image">
        {isLoaded ? (
          <ImageList activeId={activeId} setActiveId={setActiveId} mediaItems={mediaItemsList} />
        ) : (
          <div className={'image-list-slider'} />
        )}
        <MainImage
          i18n={i18n}
          productId={productId}
          activeId={activeId}
          setActiveId={setActiveId}
          mediaItems={mediaItemsList}
          setDialogVisible={setDialogVisible}
          isFavorite={isFavorite}
          abtest={abtest}
          handleFavorite={handleFavorite}
        />
      </div>
      {dialogVisible && isLoaded && (
        <ImageDialog
          i18n={i18n}
          productId={productId}
          setDialogVisible={setDialogVisible}
          activeId={activeId}
          mediaItems={mediaItemsList}
          isFavorite={isFavorite}
          handleFavorite={handleFavorite}
        />
      )}
    </div>
  );
}
